export const GET_CUSTOMER_BY_EMAIL = 'mac/FETCH_GET_CUSTOMER_BY_EMAIL';
export const IS_MEMBER_OF_GROUP = 'mac/FETCH_IS_MEMBER_OF_GROUP';
export const IS_EMAIL = 'mac/FETCH_IS_EMAIL';
export const EXTERNAL = 'mac/FETCH_EXTERNAL';
export const GET_PARTNER_NAME = 'mac/GET_PARTNER_NAME';
export const GET_CONTACTS_FOR_ORGANISATION = 'mac/GET_CONTACTS_FOR_ORGANISATION';
export const GET_VALIDATE_COUNTRY_CHANGE = 'mac/GET_VALIDATE_COUNTRY_CHANGE';
export const POST_ENABLE_DISABLE_MAIN_CONTACT = 'mac/POST_ENABLE_DISABLE_MAIN_CONTACT';
export const DELETE_CONTACT = 'mac/DELETE_CONTACT';
export const ADD_NEW_PARTNER_CONTACT = 'mac/ADD_NEW_PARTNER_CONTACT';
export const PARTNER_EMAIL_CONFIG = 'mac/PARTNER_EMAIL_CONFIG';
export const UPDATE_PARTNER_EMAIL_CONFIG = 'mac/UPDATE_PARTNER_EMAIL_CONFIG';
